export default __webpack_public_path__ + "static/media/CompleteIcon.a2019537.svg";